import { Component } from '@angular/core';
import {
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-flowpilot-chats-actions',
  imports: [FaIconComponent],
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  template: `
    @for (action of actions; track action.name) {
      <div
        class="hover:bg-dune-100 dark:hover:bg-dune-1000 flex cursor-pointer gap-x-1.5 rounded-lg px-1.5 py-1">
        <fa-icon
          class="fa-xs dark:text-dune-100/90 text-dune-700"
          [icon]="action.icon" />

        <span class="text-dune-700 dark:text-dune-100/90 text-sm text-nowrap">
          {{ action.name }}
        </span>
      </div>
    }
  `,
})
export class FlowpilotChatsActionsComponent {
  /** PROPERTIES **/
  /****/
  protected readonly actions = [
    {
      name: 'New chat',
      icon: ['fas', 'plus'] as IconProp,
    },
    {
      name: 'Search',
      icon: ['fas', 'magnifying-glass'] as IconProp,
    },
  ];

  constructor(library: FaIconLibrary) {
    library.addIcons(faPlus, faMagnifyingGlass);
  }
}
